import React from "react";
import ServicePageLayout from "./ServicePageLayout";

const WebDevelopment = () => {
  return (
    <ServicePageLayout
      imageTitle = {
        ["Build Your Digital Future with Expert Web Development!","Custom Websites | E-Commerce Solutions | Mobile-Friendly Designs"]
      }
  heroImage = "/webdevelopment-service.png"
sectionTitle = "Our AI based Web development services"
description = {
  [
  "Whether you're a small startup or an established enterprise, our web development services are tailored to meet your specific needs. We offer a wide range of services to ensure that your website stands out in the digital space.",
      ]}
benefitsTitle = ""
benefits = {
  [
  "🌐 Custom Web Design & Development",

  "📱 Mobile-Optimized Websites",

  "⚡ E-commerce Web Development",

  "🔧 CMS Web Development (WordPress, Joomla, etc.)",

  "🛠 Web Application Development",

  "🔒 Secure Web Development",

  "🚀 Website Optimization & Speed Enhancement",

  "📈 SEO-Friendly Web Development",
      ]}
secondaryImage = "/web-service-section.png"
servicesTitle = " Benefits of Web development"
services = {
  [
  {
    title: " Custom Solutions for Every Business",

    desc: "Every business is unique, and so are its web development needs. We offer customized solutions tailored to your specific goals, ensuring your website aligns perfectly with your brand. ",
  },

  {
    title: " End-to-End Web Development",

    desc: "Our developers are proficient in the latest web technologies, including HTML5, CSS3, JavaScript, PHP, and more, ensuring that your website is built with modern, scalable solutions.  ",
  },

  {
    title: "Website Optimization & Speed Enhancement",

    desc: "A slow website can turn customers away. We optimize your website’s performance to ensure fast load times, smooth user experience, and higher conversion rates. ",
  },

  {
    title: "Data-Driven Results",

    desc: "We track every interaction on your website to gather data and insights that help us continuously improve your site's performance and deliver measurable results. ",
  },

  {
    title: " Timely Delivery & Support",

    desc: "We respect your time and ensure that all projects are delivered on schedule. Additionally, our support team is always available to assist with updates or any issues post-launch. ",
  },

  {
    title: "SEO-Friendly Web Development",

    desc: "We integrate SEO best practices right into your website’s design and structure, ensuring it’s search engine-friendly and easily discoverable by your target audience. ",
  },

  {
    title: " E-commerce Web Development",

    desc: "If you need a custom web application to streamline your business operations, we build solutions that are scalable, secure, and designed to meet your specific requirements. ",
  },
      ]}
  />
  );
};

export default WebDevelopment;
